import React, { Component, Fragment } from "react";
import Header from "./Header";
import { Header as SectionHeader } from "../Header";
import CreateModel from "./CreateModel";
import PaymentMethodList from "./PaymentMethodList";
import Footer from "../../utilities/Footer";
import AppContext from "../../../contexts/AppContext";
import {
    records,
    record,
    remove,
    search,
    update,
    create
} from "../../../services/card";

export class PaymentMethod extends Component {
    state = {
        items: [],
        meta: {},
        query: "",
        search: false,
        create: false,
        loading: true,
        tableCount: "hide",
        filterItem: "all"
    };
    delete = id => {
        return remove(id).then(response => {
            let temp = this.state.items;
            for (var i in temp) {
                if (temp[i].id === id) {
                    temp.splice(i, 1);
                    this.setState({ items: temp });
                }
            }
        });
    };

    update = (id, item) => {
        return update(id, item).then(response => {
            let temp = this.state.items;
            for (var i in temp) {
                if (temp[i].id === id) {
                    temp[i] = response.data;
                    this.setState({ items: temp });
                }
            }
        });
    };

    create = item => {
        return create(item).then(response => {
            let temp = this.state.items;
            temp.unshift(response.data);
            this.setState({ items: temp });
        });
    };

    toggleCreate = () => {
        this.setState({ create: this.state.create === true ? false : true });
    };

    toggleTableCount = () => {
        this.setState({
            tableCount: this.state.tableCount === "hide" ? "show" : "hide"
        });
    };
    record = id => {
        return record(id);
    };
    onQueryChange = field => {
        this.setState({ query: field.target.value });
    };
    search = query => {
        this.setState({ loading: true });
        search(query).then(response => {
            this.setState({
                items: response.data,
                meta: response.meta,
                search: true,
                query: query,
                loading: false
            });
        });
    };

    clear = () => {
        this.setState({ loading: true });
        records(1)
            .then(response => {
                this.setState({
                    items: response.data,
                    meta: response.meta,
                    search: false,
                    filter: false,
                    loading: false
                });
            })
            .catch(error => {
                this.context.state.handelError(error);
            });
    };

    componentDidMount() {
        records(1)
            .then(response => {
                this.setState({
                    items: response.data,
                    meta: response.meta,
                    loading: false
                });
            })
            .catch(error => {
                this.context.state.handelError(error);
            });
    }
    changePage = page => {
        if (this.state.search === true) {
            search(this.state.query, page).then(response => {
                this.setState({ items: response.data, meta: response.meta });
            });
        } else {
            records(page).then(response => {
                this.setState({ items: response.data, meta: response.meta });
            });
        }
    };
    submitSearch = e => {
        e.preventDefault();
        if (this.state.query.length >= 1) {
            this.search(this.state.query);
        } else {
            this.clear();
        }
    };
    render() {
        return (
            <Fragment>
                <SectionHeader></SectionHeader>
                <div className="main-content  mt-6">
                    <div className="container">
                        <div className="row justify-content-center">
                            <div className="col-12">
                                <Header
                                    match={this.props.match}
                                    title="Payment"
                                    subTitle="OVERVIEW ALL PAYMENT METHOD"
                                ></Header>

                                {this.state.items.length >= 1 ? (
                                    <div className="card">
                                        <div className="table-responsive">
                                            <table className="table table-sm table-nowrap card-table">
                                                <thead>
                                                    <tr>
                                                        <th>
                                                            <div className="custom-control custom-checkbox table-checkbox">
                                                                #
                                                            </div>
                                                        </th>
                                                        <th>Number</th>
                                                        <th>Date</th>
                                                        <th className="Options">
                                                            Options
                                                        </th>
                                                    </tr>
                                                </thead>
                                                <tbody className="list">
                                                    {this.state.items.map(
                                                        (item, index) => {
                                                            return (
                                                                <PaymentMethodList
                                                                    getItem={
                                                                        this
                                                                            .record
                                                                    }
                                                                    update={
                                                                        this
                                                                            .update
                                                                    }
                                                                    delete={
                                                                        this
                                                                            .delete
                                                                    }
                                                                    item={item}
                                                                    index={
                                                                        index
                                                                    }
                                                                    key={index}
                                                                ></PaymentMethodList>
                                                            );
                                                        }
                                                    )}
                                                </tbody>
                                            </table>
                                            <div>
                                                <Footer
                                                    changePage={this.changePage}
                                                    totalPages={
                                                        this.state.meta.pages
                                                    }
                                                    curentPage={
                                                        this.state.meta.page
                                                    }
                                                ></Footer>
                                            </div>
                                        </div>
                                    </div>
                                ) : (
                                    <div className="card-body text-center">
                                        <div className="row justify-content-center">
                                            <div className="col-12 col-md-10 col-xl-8">
                                                <img
                                                    src="/images/paymentMethodPage.png"
                                                    className="img-fluid mt-n5 mb-4 bg-image"
                                                    alt=""
                                                />
                                                <h2>
                                                    You have no cards in the
                                                    system
                                                </h2>

                                                <p className="text-muted">
                                                    Please enter your payment
                                                    card data below. You can use
                                                    a credit / debit card .
                                                </p>

                                                <button
                                                    onClick={this.toggleCreate}
                                                    className="btn btn-primary"
                                                >
                                                    Add card
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
                {this.state.create === true ? (
                    <CreateModel
                        create={this.create}
                        hideCreate={this.toggleCreate}
                    ></CreateModel>
                ) : null}
            </Fragment>
        );
    }
}
PaymentMethod.contextType = AppContext;
export default PaymentMethod;



// WEBPACK FOOTER //
// ./src/components/employer/billing/PaymentMethod.js